import React from "react";

const ProductRange = () => {
  return (
    <div className="container mx-auto text-center px-4 py-12">
      {/* Heading */}
      <h2 className="text-black font-bold text-4xl mb-4">OUR RANGE</h2>

      {/* Description */}
      <p className="text-gray-700 text-sm max-w-6xl mx-auto">
        Menstruation is a natural process, and every woman deserves comfort and confidence during this time. The discomfort of wearing synthetic pads and the fear of leaks shouldn’t hold you back. With <strong>Organic Pads</strong>, you get 100% protection from leaks while enjoying the gentle touch of ultra-soft, organic cotton. Our pads are completely free from harsh chemicals, ensuring they remain safe for your skin, even during prolonged wear. Plus, their breathable design helps prevent moisture buildup, keeping you fresh and irritation-free throughout the day.
      </p>
      <p className="text-gray-700 text-sm max-w-6xl mx-auto mt-4">
        Our range of **100% organic cotton pads** is designed to meet the unique needs of every woman. Whether you prefer ultra-thin, extra-absorbent, or night-time protection, we have the perfect option for you. Available online, our detailed buying guide ensures you find the best fit for your flow, so you can experience a healthier, more comfortable period—naturally.
      </p>


      {/* Product List */}
      <div className="flex flex-wrap justify-center gap-8 mt-8">
        {/* Product Item */}

        <div className="text-center">
          <img src="/images/product-image.png" alt="Naturally Soft" className="w-80 h-auto mx-auto" />
          <p className="text-gray-600 text-lg mt-2">Naturally Soft</p>
        </div>
      </div>

      {/* Button */}
      <a
        href="/products"
        className="bg-[#679729] text-white font-bold px-6 py-3 mt-8 rounded-full transition inline-block"
      >
        VIEW MORE
      </a>

    </div>
  );
};

export default ProductRange;
